import type { GeneralConfig } from '@shared/types/Config';

export const clientConfig: GeneralConfig = {
    sortFieldMap: {
        'state.data._3_letter_code': 'states|_3_letter_code',
        'country.data.name': 'countries|name',
    },
};
